module.exports = __webpack_public_path__ + "assets/f5ab8fd9a634dad342b44b085c5a5abf.mp3";